import * as React from 'react';
import * as WjInput from '@mescius/wijmo.input';
import {Popup} from '@mescius/wijmo.react.input';
import { Button } from 'react-bootstrap';
import { useAppComponentStore } from './stores/appComponentStore';

/**
 * メッセージボックス表示用
 * @param  
 * @returns 
 */
export const AppMessageBox = () =>{
    const store = useAppComponentStore((state) => state.messageBox);

    const popupRef = React.useRef<WjInput.Popup>(null);

    let styleBtn:React.CSSProperties = {
        minWidth:"6.25rem",
    }

    React.useEffect(() => {
        if(store.isPopupInitialized){
            if(store.isDisplay)
                popupRef?.current.show();
            else
                popupRef?.current.hide();
            }
    },[store.isDisplay ,store.isPopupInitialized])

    /**
     * ポップアップの初期化
     */
    const onPopupInitialized = ((popup:any) => {
        popupRef.current = popup;
        store.popupInitialized();
    });

    const messagebox = React.useMemo(()=>{
        const onClickPositiveButton = () =>{
            if(store.onPositiveButtonClick != undefined)
                store.onPositiveButtonClick();
    
            store.hide();
        }
        const onClickNagativeButton = () =>{
            if(store.onNagativeButtonClick != undefined)
                store.onNagativeButtonClick();
    
            store.hide();
        }
        const onClickCancelButton = () =>{
            if(store.onCancelButtonClick != undefined)
                store.onCancelButtonClick();
    
            store.hide();
        }

        return(            
            <Popup initialized={onPopupInitialized} modal={true} hideTrigger={0} ref={popupRef}>
                <div className="modal-header bg-primary text-light p-2">
                    <h5 className="modal-title">{store.title}</h5>
                </div>
                <div className="modal-body">
                    <p className="p-4" style={{whiteSpace:"pre-wrap"}}>{store.message}</p>
                </div>
                <div className="modal-footer p-2">
                    <Button variant="btn btn-success" style={styleBtn} onClick={onClickPositiveButton}>{store.positiveButtonTitle}</Button>
                    <Button variant="btn btn-danger ms-2" style={styleBtn} onClick={onClickNagativeButton}>{store.nagativeButtonTitle}</Button>
                </div>
            </Popup>
        );
    }, [store.isDisplay]);

    return(
        <>
            {messagebox}
        </>
    );
}